const {Component} = require("react");
const {Picker} = require("emoji-mart");
const router = require("services/router");

class PickerWrapper extends Component {

	get emojiOptions() {
		return {
			color: "#FF4789",
			set: 'emojione',
			showSkinTones: false,
			onSelect: this.props.onSelect,
			i18n: {
				search: 'Søg',
				notfound: 'Ingen emoji fundet',
				categories: {
					search: 'Søgeresultater',
					recent: 'Ofte anvendt',
					people: 'Smileys og Mennesker',
					nature: 'Dyr og Natur',
					foods: 'Mad og Drikker',
					activity: 'Aktivitet',
					places: 'Rejser og Steder',
					objects: 'Objekter',
					symbols: 'Symboler',
					flags: 'Flag',
					custom: 'Andet',
				}
			}
		};
	}

	render() {
		return (
			<Picker {...this.emojiOptions} />
		);
	}
}

class EmojiPicker extends Component {

	/*
	-------------------------------
	Config
	-------------------------------
	*/

	constructor(props) {
		super(props);

		this.state = {
			active: false
		};
	}

	componentDidUpdate() {
		if (this.state.active) {
			document.addEventListener("click", this.closeAway);
			document.onkeydown = this.closeEscape;
		} else {
			document.removeEventListener("click", this.closeAway);
			document.onkeydown = null;
		}
	}


	/*
	-------------------------------
	Getters
	-------------------------------
	*/

	get picker() {
		return document.querySelector(".emoji-mart") || null;
	}


	/*
	-------------------------------
	Event handlers
	-------------------------------
	*/

	closeEscape = (e) => {
		if (e.keyCode === 27) this.close();
	}

	closeAway = (e) => {
		if (!this.picker) return;

		let clickedInside = this.picker.contains(e.target);

		if (!clickedInside) this.close();
	}

	close() {
		this.setState({active: false});
	}

	toggl = (e) => {
		e.preventDefault();
		e.stopPropagation();

		let state = !this.state.active;
		this.setState({active: state});
	}


	/*
	-------------------------------
	Renders
	-------------------------------
	*/

	renderPicker() {
		if (!this.state.active) return;

		return (
			<PickerWrapper onSelect={this.props.onSelect} />
		);
	}

	renderButton() {
		return (
			<a className="smiley-picker" onClick={this.toggl} >
				<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 22 22'>
					<g transform='translate(-7529 -9479)'>
						<g transform='translate(496)'>
							<g transform='translate(1001 1040)'>
								<circle className='st0' cx='6043' cy='8450' r='11' />
								<circle className='st1' cx='6043' cy='8450' r='10.5' />
							</g>
							<circle className='st2' cx='7041' cy='9487' r='1' />
							<circle className='st2' cx='7047' cy='9487' r='1' />
							<path className='st1' d='M7039.4,9492.5c0,0,4.5,5.4,9.3,0' />
						</g>
					</g>
				</svg>
			</a>
		);
	}

	render() {
		return (
			<React.Fragment>
				{this.renderButton()}
				{this.renderPicker()}
			</React.Fragment>
		);
	}
}

module.exports = EmojiPicker;



// WEBPACK FOOTER //
// ./resources/js/components/backend/chat/EmojiPicker.js